// src/modules/jobs/ScheduledJobs.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Map from '../../components/shared/Map';
import { getJobsScheduled } from './jobsService'; // Create a function to fetch scheduled jobs
import { format, parseISO } from 'date-fns';
import { FaCalendar } from 'react-icons/fa';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  h2, h3{margin: 0px;padding: 0px;padding-bottom: 2em;}
`;

const JobList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid ${(props) => props.theme.colors.inputGray};
  padding: ${(props) => props.theme.spacing(2)};
  margin-bottom: ${(props) => props.theme.spacing(3)};
`;

const JobItem = styled.div`
  padding: ${(props) => props.theme.spacing(2)};
  margin-bottom: ${(props) => props.theme.spacing(1)};
  background-color: ${(props) => props.theme.colors.background};
  border-radius: ${(props) => props.theme.borderRadius};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  &:hover {
    background-color: ${(props) => props.theme.colors.surface};
  }
`;

const JobInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScheduledJobs = ({ currentJobLatLng }) => {

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchScheduledJobs = async () => {
    setLoading(true);
    try {
      const data = await getJobsScheduled(); // Implement this API function to fetch jobs
      setJobs(data);
    } catch (error) {
      console.error('Error fetching scheduled jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch scheduled jobs for the next 30 days
  useEffect(() => {
    fetchScheduledJobs();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return 'Invalid Date'; // Handle cases where dateString is undefined or null
    try {
      const parsedDate = parseISO(dateString); // Parse the date string into a Date object
      return format(parsedDate, 'MM/dd/yyyy'); // Format to "MM/dd/yyyy"
    } catch (error) {
      console.error("Error formatting date:", error);
      return 'Invalid Date';
    }
  };

  const mapAddresses = [
    {
      lat: currentJobLatLng.lat,  // Latitude of the current job
      lng: currentJobLatLng.lng,  // Longitude of the current job
      title: 'Current Job Location',
      customerName: 'Current Job',
      estimateId: null,
      city: '',
      services: [],
      totalArea: null,
      startDate: '',
      endDate: '',
      isJob: true, // This flag indicates that it's a job pin
      isSupplier: false, // Ensure supplier flag is false
    },
    ...jobs.map((job) => {
      const [lat, lng] = job.geolocation.split(';').map(coord => parseFloat(coord.trim())); // Split and parse lat/lng

      return {
        lat: lat,  // Latitude from the split geolocation
        lng: lng,  // Longitude from the split geolocation
        title: job.customer_name,
        customerName: job.customer_name,
        estimateId: job.estimate_id,
        city: job.job_city,
        services: job.services,  // Ensure that the job object has a `services` array
        totalArea: job.total_area,
        startDate: formatDate(job.scheduled_start_date),
        endDate: formatDate(job.scheduled_end_date),
        isJob: true, // This flag indicates that it's a job pin
        isSupplier: false, // Ensure supplier flag is false
      };
    })
  ];

  return (
    <Wrapper>
      <h3><FaCalendar /> Scheduled Jobs for the Next 30 Days</h3>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <JobList>
            {jobs.map((job, index) => (
              <JobItem key={index}>
                <JobInfo>
                  <strong>{job.customer_name} | {job.job_city} - {formatDate(job.scheduled_start_date)} / {formatDate(job.scheduled_end_date)}</strong>
                  <span>Serviços: {job.services.map(service => service.service_name).join(', ')}</span>
                  <span>Total Area: {job.total_area} sqft</span>
                </JobInfo>
              </JobItem>
            ))}
          </JobList>
          <Map addresses={mapAddresses} zoom={11} center={currentJobLatLng} />
        </>
      )}
    </Wrapper>
  );
};

export default ScheduledJobs;
